export default class Api {
  constructor($http, $q, API_URL) {
    "ngInject"
    this.API_URL = API_URL;
    this.$http = $http;
    this.$q = $q;
  }

  call(params) {

    let
      isAbsolute = 0 === params.url.indexOf("http://");
    if (!isAbsolute) {
      params.url = this.API_URL + params.url;
    }

    return this.$http(params)
      .then((response) => response.data)
      .catch((error) => {
        throw error
      });
  }
}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/common/services/api.js
 **/